import { AccountInfo } from "@azure/msal-browser";
import { defaultKusto } from "./Kusto";

const portalEntityGroup = defaultKusto.portalEntityGroup;

function doMicroExpand() {
    return !!portalEntityGroup;
}

export function getPortalTable(options: {
    database: "AzurePortal" | "AzPtlCosmos",
    table: "ClientTelemetry" | "ClientEvents" | "ExtTelemetry" | "ExtEvents" | "FeedbackTelemetry" | "SvcSessions" | "ClientAjax" | "PortalFeedbackEnhanced",
    activeAccount: AccountInfo | null,
}) {
    const { database, table } = options;
    return doMicroExpand() ? `X.database('${database}').${table}` : `database('${database}').${table}`;
}

export function getPortalQuery(options: { baseQuery: string, groupQuery: string, beforeQuery?: string, activeAccount: AccountInfo | null }) {
    const { baseQuery, groupQuery, beforeQuery } = options;
    let query: string = beforeQuery || "";
    if (doMicroExpand()) {
        query += `macro-expand isfuzzy=true force_remote=true ${portalEntityGroup} as X
(
${baseQuery.split("\n").map(line => `    ${line}`).join("\n")}
)`;
    } else {
        query += baseQuery
    }

    if (groupQuery) {
        query += `
${groupQuery}`;
    }

    return query;
}
